import Config from '@gral/config.json';

export const getAuthority = () => {
  const tenantId = Config.SSO.tenantId;
  const clientId = Config.SSO.clientId;
  const responseType = Config.SSO.responseType;
  //const prompt = Config.SSO.prompt;
  const codeChallenge = Config.SSO.code_challenge;
  const codeChallengeMethod = Config.SSO.code_challenge_method;
  const scope = encodeURIComponent(Config.SSO.scope);
  const redirectUri = encodeURIComponent(window.location.origin + Config.SSO.redirectUri);

  return `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=${responseType}&redirect_uri=${redirectUri}&scope=${scope}&code_challenge=${codeChallenge}&code_challenge_method=${codeChallengeMethod}`;
};

//const msalConfig: Configuration = {
//  auth: {
//    clientId: Config.SSO.clientId,
//    authority: getAuthority(),
//    redirectUri: window.location.origin + Config.SSO.redirectUri,
//  },
//};
//
//export const msalInstance = new PublicClientApplication(msalConfig);
